export default "__VITE_ASSET__BMv6jUMf__"